import { configureStore } from '@reduxjs/toolkit';
import styleReducer from './styleSlice';
import mainReducer from './mainSlice';
import authSlice from './authSlice';
import openAiSlice from './openAiSlice';

import usersSlice from "./users/usersSlice";
import rolesSlice from "./roles/rolesSlice";
import permissionsSlice from "./permissions/permissionsSlice";
import teacher_profilesSlice from "./teacher_profiles/teacher_profilesSlice";
import skillsSlice from "./skills/skillsSlice";
import teaching_experiencesSlice from "./teaching_experiences/teaching_experiencesSlice";
import gallery_categoriesSlice from "./gallery_categories/gallery_categoriesSlice";
import gallery_itemsSlice from "./gallery_items/gallery_itemsSlice";
import subjectsSlice from "./subjects/subjectsSlice";
import grade_levelsSlice from "./grade_levels/grade_levelsSlice";
import teaching_modulesSlice from "./teaching_modules/teaching_modulesSlice";
import material_categoriesSlice from "./material_categories/material_categoriesSlice";
import learning_materialsSlice from "./learning_materials/learning_materialsSlice";
import toolsSlice from "./tools/toolsSlice";
import social_linksSlice from "./social_links/social_linksSlice";
import contact_messagesSlice from "./contact_messages/contact_messagesSlice";
import site_settingsSlice from "./site_settings/site_settingsSlice";

export const store = configureStore({
  reducer: {
    style: styleReducer,
    main: mainReducer,
    auth: authSlice,
    openAi: openAiSlice,

users: usersSlice,
roles: rolesSlice,
permissions: permissionsSlice,
teacher_profiles: teacher_profilesSlice,
skills: skillsSlice,
teaching_experiences: teaching_experiencesSlice,
gallery_categories: gallery_categoriesSlice,
gallery_items: gallery_itemsSlice,
subjects: subjectsSlice,
grade_levels: grade_levelsSlice,
teaching_modules: teaching_modulesSlice,
material_categories: material_categoriesSlice,
learning_materials: learning_materialsSlice,
tools: toolsSlice,
social_links: social_linksSlice,
contact_messages: contact_messagesSlice,
site_settings: site_settingsSlice,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
